import { render, staticRenderFns } from "./ServiceMobile.vue?vue&type=template&id=016c0c15&scoped=true&"
import script from "./ServiceMobile.vue?vue&type=script&lang=js&"
export * from "./ServiceMobile.vue?vue&type=script&lang=js&"
import style0 from "./ServiceMobile.vue?vue&type=style&index=0&id=016c0c15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016c0c15",
  null
  
)

export default component.exports